import {Drawer} from "//wellboxes.co.uk/cdn/shop/t/44/assets/theme.js?v=45972817138175999841765220852"; // Import the theme web component

class upSellDrawer extends Drawer {
    constructor(){
        super();
        //this.querySelector('button[name="Skip Customisation"]').addEventListener('click', this._skipUpsell.bind(this));
        this.addEventListener("submit", this._onSubmit);
        // this.upsellQuantity = this.querySelector('button[name="Skip Customisation"]');
        this._onVariantToBeAddedListener = this._onVariantToBeAdded.bind(this);
        this._SubmitUpsellsListener = this._SubmitUpsells.bind(this);
    }
    connectedCallback() {
        super.connectedCallback();
        document.addEventListener("product:upsell", this._onVariantToBeAddedListener);
        this.addEventListener('product:upsell:added', this._SubmitUpsellsListener);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener("product:upsell", this._onVariantToBeAddedListener);
        this.removeEventListener('product:upsell:added', this._SubmitUpsellsListener);
    }

    _onVariantToBeAdded(event){
        this.show();
        this.passedFormData = event.detail.formData;
        this.createAllowedUpsellOptions(this.passedFormData);
    }

    async _skipUpsell(event){
        event.preventDefault();
        this._SubmitPrevious(event); 
    }
    
    async _onSubmit(event){
        event.preventDefault();
        const formData = new FormData(this.querySelector('form'));
       

        /// SUBMIT VARIANT FROM PREVIOUS FORM
        /// TODO: ADD GROUP ID & CHOSEN VARIANT OPTIONS   
        if(formData.get('id') === 'default' && !formData.get('shipping_id')){
            /// NO NEED FOR UPSELLS 
            this._SubmitPrevious(event); 
        } else {
            /// ADD UPSELLS 

            /// CREATE BASE UPSELL OBJECT
            let upsell = {
                         'id': this.groupID() * 1,
                         'qty': this.passedFormData.get('quantity')
                        }
            /// IF PRODUCT UPSELL IS NOT THE DEFAULT ADD TO UPSELL OBJECT
            if(formData.get('id') != 'default'){
                var selected_product = this.querySelector('form').querySelector('input[name="id"]:checked').dataset.name;
                var min_qty = this.querySelector('form').querySelector('input[name="id"]:checked').min;
                upsell.product_id = +formData.get('id') * 1;
                upsell.product_name = selected_product;
                upsell.min_qty = min_qty;
            }
            /// IF SHIPPING UPSELL IS NOT THE DEFAULT ADD TO UPSELL OBJECT
            if(formData.get('shipping_id')){
                var selected_shipping = this.querySelector('form').querySelector('input[name="shipping_id"]:checked').dataset.name;
                upsell.shipping_id = formData.get('shipping_id') * 1;
                upsell.shipping_name = selected_shipping;
            }
            /// SUBMIT PREVIOUS FORM WITH GROUP DETAILS
           this._SubmitPrevious(event, upsell);
        
        }
            
    }


    async _SubmitPrevious(event, upsells){
        event.preventDefault();
        //// CHECK IF UPSELLS EXISTS
        if(upsells){
            /// CREATE THE FORM DETAILS FOR THE VARIANT TO BE ADDED
            this.passedFormData.set('properties[_group_id]', upsells.id);
            this.passedFormData.set('properties[_group_type]', 'parent');
            /// IF PRODUCT IS NOT DEFAULT ADD TO THE PASSED FORM DATA
            if("product_id" in upsells){
                this.passedFormData.set('properties[_upsell_name]', upsells.product_name);
                this.passedFormData.set('properties[_upsell_id]', upsells.product_id);
                this.passedFormData.set('properties[_min_qty]', upsells.min_qty);
            }
            /// IF SHIPPING IS NOT DEFAULT ADD TO THE PASSED FORM DATA
            if("shipping_id" in upsells){
                this.passedFormData.set('properties[_shipping_name]', upsells.shipping_name);
                this.passedFormData.set('properties[_shipping_id]', upsells.shipping_id);
            }
            
        }
        /// SUBMIT THE PREVIOUS FORM DATA
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
            body: this.passedFormData,
            method: "POST",
            headers: {
            "X-Requested-With": "XMLHttpRequest"
            // Needed for Shopify to check inventory
            }
        });

        const responseJson = await response.json();
        if (response.ok) {
        
            if(upsells){
                        /// ADD THE VARIANT TO UPSELLS 
                    upsells.variant_name = responseJson.handle;
                    upsells.variant_id = responseJson.id;
                    // HAS UPSELLS SO FIRE UPSELL ADDED EVENTS
                     this.dispatchEvent(new CustomEvent("product:upsell:added", {
                    bubbles: true,
                    detail: {
                    upsells: upsells
                    }
                }));
            }
            else {
                /// NO UPSELLS SO REFRESH CART AND FIRE ADDED TO CART EVENTS
                const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
                cartContent["sections"] = responseJson["sections"];
                    this.dispatchEvent(new CustomEvent("variant:add", {
                    bubbles: true,
                    detail: {
                    items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
                    cart: cartContent
                    }
                }));
                document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                    baseEvent: "variant:add",
                    cart: cartContent
                    }
                }));
                this.hide();
                var submitButtons = this.querySelectorAll('button[type="submit"]');
                submitButtons.forEach((submitButton) => {
                    submitButton.removeAttribute("disabled");
                    submitButton.removeAttribute("aria-busy");
                });
            }
         
        
        } else {
           console.log(response);
        }
    }

    async _SubmitUpsells(event){
        // FROM EVENT PASSED GRAB THE UPSELLS AND THE ADDED PRODUCTS
        let upsells = event.detail.upsells;

        let upsellToAdd = { "items": [],"sections":this.passedFormData.get('sections')};

        if(upsells.product_id){
                    var product_upsell = {
                                'id': upsells.product_id,
                                'quantity': upsells.qty,
                                'properties': { 
                                    '_group_id': upsells.id.toString(),
                                    '_group_type': 'upsell',
                                    '_product_name': upsells.variant_name,
                                    '_product_id': upsells.variant_id.toString(),
                                    '_min_qty': parseInt(upsells.min_qty)
                                }
                            }

        upsellToAdd.items.push(product_upsell);
        }

        if(upsells.shipping_id){
            var shipping_upsell = {
                        'id': upsells.shipping_id,
                        'quantity': upsells.qty,
                        'properties': { 
                            '_group_id': upsells.id.toString(),
                            '_group_type': 'shipping',
                            '_product_name': upsells.variant_name,
                            '_product_id': upsells.variant_id.toString()
                        }
                    }

        upsellToAdd.items.push(shipping_upsell);
        }
   
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
            body: JSON.stringify(upsellToAdd),
            method: "POST",
            headers: {
             'Content-Type': 'application/json',
             "X-Requested-With": "XMLHttpRequest"
            }
        });
        var submitButtons = this.querySelectorAll('button[type="submit"]');
        submitButtons.forEach((submitButton) => {
            submitButton.removeAttribute("disabled");
            submitButton.removeAttribute("aria-busy");
          });
        const responseJson = await response.json();
        if (response.ok) {
          

            const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
            cartContent["sections"] = responseJson["sections"];
        
            this.dispatchEvent(new CustomEvent("variant:add", {
                bubbles: true,
                detail: {
                items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
                cart: cartContent
                }
            }));
            document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                baseEvent: "variant:add",
                cart: cartContent
                }
            }));
            
                this.hide();
        
        }
    }


groupID(){
    var min = 1000000;
    var max = 9999999;
    return Math.floor(Math.random() * (max - min + 1)) + min;
}


createAllowedUpsellOptions(formData){
        let product_qty = formData.get("quantity");
        // this.querySelector("[name='quantity']").value = product_qty;
        //find variant min order and set available options        
        
        this.upsellItems = this.querySelectorAll('.upsell-item');
        this.upsellItems.forEach(upsellItem => {
            var radioButton = upsellItem.querySelector("[name='id']");
            radioButton.disabled = ( product_qty >= Number(radioButton.min) ) ? false : true ;
        });

        this.upsellShippingItems = this.querySelectorAll('.upsell-shipping');
        this.upsellShippingItems.forEach(upsellShipping => {
            var checkbox = upsellShipping.querySelector("[name='shipping_id']");
            checkbox.disabled = ( product_qty <= Number(checkbox.max) ) ? false : true ;
        });

    }

}

window.customElements.define('upsell-drawer', upSellDrawer);


// class upSellDrawer extends Drawer {


// }

// window.customElements.define('customise-tooltip', customiseTooltop);